// Flechitas en las tarjetas de producto: se pasan las fotos sin entrar al producto.
(function () {
  function mover(galeria, paso) {
    var fotos = galeria.querySelectorAll('.mq-galeria__foto');
    var puntos = galeria.querySelectorAll('.mq-galeria__punto');
    if (fotos.length < 2) return;

    var actual = 0;
    for (var i = 0; i < fotos.length; i++) {
      if (fotos[i].classList.contains('is-activa')) actual = i;
    }
    var siguiente = (actual + paso + fotos.length) % fotos.length;

    fotos[actual].classList.remove('is-activa');
    fotos[siguiente].classList.add('is-activa');
    if (puntos.length === fotos.length) {
      puntos[actual].classList.remove('is-activo');
      puntos[siguiente].classList.add('is-activo');
    }
  }

  document.addEventListener('click', function (evento) {
    var flecha = evento.target.closest('.mq-galeria__flecha');
    if (!flecha) return;
    evento.preventDefault();
    evento.stopPropagation();
    mover(flecha.closest('[data-mq-galeria]'), parseInt(flecha.dataset.mqPaso, 10));
  });
})();
